module.exports = __webpack_public_path__ + "53f787b9a8a6d57afa7b01f5a5bc629e.jpg";